import React, { useState } from 'react';
import { Logo } from './Logo';
import { useStore, levelMetaForPoints, nextLevelForPoints, LEVELS, GAME_UNLOCK_LEVEL } from '../lib/store';
import { Star, X, Lock, CheckCircle2 } from 'lucide-react';
export function AppHeader() {
  const {
    user
  } = useStore();
  const [showLevelsModal, setShowLevelsModal] = useState(false);
  const points = user?.points ?? 0;
  const level = levelMetaForPoints(points);
  const next = nextLevelForPoints(points);
  // Progress toward the next tier (full bar when the user has maxed out).
  const span = next ? next.min - level.min : 1;
  const progress = next ? Math.min(100, Math.round((points - level.min) / span * 100)) : 100;
  return <>
      <header className="bg-brand-ice/95 backdrop-blur px-5 py-3 flex items-center justify-between sticky top-0 z-50 border-b border-white/80 shadow-[0_8px_26px_rgba(22,38,95,0.05)]" data-id="element-83" data-mp="1js2hfikjd96a">
        <div className="flex items-center space-x-2" data-id="element-84" data-mp="2v8tvahv44an0">
          <div className="w-40" data-id="element-85" data-mp="2vadccaoleppu">
            <Logo variant="light" data-id="element-86" data-mp="3m1jn3vk7wuns" />
          </div>
        </div>
        {user && <button onClick={() => setShowLevelsModal(true)} className="bg-white px-3 py-2 rounded-full flex items-center space-x-2 shadow-[0_8px_22px_rgba(22,38,95,0.10)] hover:-translate-y-0.5 transition-transform" data-id="element-87" data-mp="3r0cst1t9jhde">
            <div className="flex flex-col items-end leading-none" data-id="element-88" data-mp="3udj11b4ff6i">
              <span className="text-[10px] text-brand-purple font-bold uppercase tracking-wider flex items-center gap-1" data-id="element-89" data-mp="33bbq7v7430g1">
                <span aria-hidden="true" data-id="element-90" data-mp="37df1aipvc30s">{level.emoji}</span>
                {level.name}
              </span>
              <span className="text-brand-navy text-xs font-bold mt-0.5" data-id="element-91" data-mp="3c9x61il781d4">
                {points} pts
              </span>
              {/* Progress to next tier */}
              <div className="w-20 h-1 bg-brand-lavender rounded-full overflow-hidden mt-1" data-id="element-92" data-mp="2jnccqcl5xf6x">
                <div className="h-full bg-brand-purple rounded-full transition-all duration-500" style={{
              width: `${progress}%`
            }} data-id="element-93" data-mp="2oldw6ymi3gix" />
              </div>
            </div>
            <div className="w-7 h-7 bg-brand-purple rounded-full flex items-center justify-center shadow-[0_5px_12px_rgba(96,70,232,0.28)]" data-id="element-94" data-mp="3mvm62o6jsdtn">
              <Star className="w-3.5 h-3.5 text-brand-yellow fill-current" data-id="element-95" data-mp="hm2zpcpwos8" />
            </div>
          </button>}
      </header>

      {/* Levels Modal */}
      {showLevelsModal && <div className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-96" data-mp="33zdxpbi8nmu4">
          <div className="bg-white rounded-3xl w-full max-w-sm relative overflow-hidden flex flex-col max-h-[90vh]" data-id="element-97" data-mp="3hzezqua8p0b6">
            <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-brand-light" data-id="element-98" data-mp="3cy7qeqsg7t2e">
              <div data-id="element-99" data-mp="xahhnvevdiac">
                <h2 className="text-2xl font-display text-brand-blue uppercase tracking-wide" data-id="element-100" data-mp="s9boxxl7lv0t">
                  Your Level
                </h2>
                <p className="text-sm text-gray-500 font-medium" data-id="element-101" data-mp="10p9cc3vvhtvh">
                  {points} Points Total
                </p>
              </div>
              <button onClick={() => setShowLevelsModal(false)} className="p-2 bg-white rounded-full text-gray-400 hover:text-gray-600 shadow-sm" data-id="element-102" data-mp="14pkth6p11c27">
                <X className="w-5 h-5" data-id="element-103" data-mp="vt2dev1w9in1" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto space-y-4" data-id="element-104" data-mp="1jhlk565apnd0">
              {LEVELS.map((lvl, idx) => {
            const isCurrent = level.name === lvl.name;
            const isUnlocked = points >= lvl.min;
            const isHighest = idx === LEVELS.length - 1;
            return <div key={lvl.name} className={`relative p-4 rounded-2xl border-2 transition-all ${isCurrent ? 'border-brand-blue bg-brand-blue/5 shadow-md' : isUnlocked ? 'border-green-100 bg-white' : 'border-gray-100 bg-gray-50 opacity-75'}`} data-id="element-105" data-mp="1eo9079bka4ql" data-mpi={idx}>
                    {isCurrent && <div className="absolute -top-3 right-4 bg-brand-blue text-brand-yellow text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full" data-id="element-106" data-mp="eigj422q1a7s">
                        Current
                      </div>}
                    <div className="flex items-center justify-between" data-id="element-107" data-mp="4mmxlt70y6dv">
                      <div className="flex items-center space-x-3" data-id="element-108" data-mp="127j2pfgx1d4x">
                        <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl ${isUnlocked ? 'bg-white shadow-sm' : 'bg-gray-200'}`} data-id="element-109" data-mp="x9pru94o3uyb">
                          {lvl.emoji}
                        </div>
                        <div data-id="element-110" data-mp="1kz21fa3wq515">
                          <h3 className={`font-bold ${isUnlocked ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-111" data-mp="1kzbs6zws0g7w">
                            {lvl.name}
                          </h3>
                          <p className="text-xs text-gray-500 font-medium" data-id="element-112" data-mp="1nl1cszaykjqr">
                            {lvl.min} pts
                          </p>
                        </div>
                      </div>
                      <div data-id="element-113" data-mp="1xg35240j61xk">
                        {isUnlocked ? <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-114" data-mp="22hsfbhfxibkl" /> : <Lock className="w-5 h-5 text-gray-400" data-id="element-115" data-mp="26hawq38jk4io" />}
                      </div>
                    </div>
                    {isHighest && <div className="mt-3 pt-3 border-t border-gray-200/50" data-id="element-116" data-mp="2g7vujoge550j">
                        <p className="text-xs font-medium text-brand-blue flex items-center" data-id="element-117" data-mp="2l6z2phro3rcq">
                          <Star className="w-3.5 h-3.5 mr-1 text-brand-yellow fill-current" data-id="element-118" data-mp="2q6bkho3om88g" />
                          Unlocks Virtual Fishing Game
                        </p>
                      </div>}
                  </div>;
          })}
            </div>
          </div>
        </div>}
    </>;
}